export default "__VITE_ASSET__dff9c71c__"